import { defineComponent as _defineComponent } from 'vue';
import { createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/login/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-49677d43"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "panel-company flex-full"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"company-header\" data-v-49677d43><div class=\"title\" data-v-49677d43>宁波艺星</div><div class=\"front\" data-v-49677d43>会话管家</div></div><div class=\"img-icon\" data-v-49677d43><img src=\"" + _imports_0 + "\" alt=\"\" data-v-49677d43></div>", 2);
const _hoisted_4 = [_hoisted_2];
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'panel-company',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
    };
  }
});